import { defaultLayoutState } from './module-layout-state';

export default {
	resetState(state) {
		Object.assign(state, defaultLayoutState);
	},
	updateLayout(state, res) {
		if (res && res.LayoutValue) {
			state[res.LayoutID] = JSON.parse(res.LayoutValue);
		}
	},
	resetLayout(state, layoutID) {
		if (layoutID) {
			state[layoutID] = null;
		}
	}
};
